import { useSelector } from "react-redux";
import "../../style/mobile/home/M_NewestExams.scss";
// import img1 from '../../../assets/store/amazing-suggest/ella-olsson-KPDbRyFOTnE-unsplash.jpg';
// import img2 from '../../../assets/store/amazing-suggest/antoine-dautry-_zsL306fDck-unsplash.jpg';
// import img3 from '../../../assets/store/amazing-suggest/ahmed-almakhzanji-kshkB1i5_5o-unsplash.jpg';
import icon1 from "../../../assets/mobile/home/vuesax-linear-calendar.svg";
import icon2 from "../../../assets/mobile/home/vuesax-linear-profile-2user.svg";
import icon3 from "../../../assets/mobile/home/vuesax-linear-teacher.svg";
// import icon4 from '../../../assets/mobile/home/discount-shape.svg';
import React, { useState } from "react";
import moment from "jalali-moment";

const M_NewestExams = () => {
  const state = useSelector((state) => state.default);
  const [data] = useState(state.ExamData);

  moment.locale("en");
  return (
    <div className="M_NewestExams">
      <div className="M_NewestExams-title">جدیدترین آزمون ها</div>
      <div className="M_NewestExams-body">
        {data.map((item, index) => (
          <React.Fragment key={index}>
            {index < 4 && (
              <div className="M_NewestExams-body-item">
                <div className="M_NewestExams-body-item-img-container">
                  <img src={item.img} alt="item-img" />
                  <div className="M_NewestExams-body-item-img-container-cover"></div>
                </div>
                <div className="M_NewestExams-body-item-title">
                  {item.name}
                </div>
                <div className="M_NewestExams-body-item-price-box">
                  <div
                    style={
                      item.badge
                        ? { textDecoration: "line-through", color: "#A7A5A5" }
                        : null
                    }
                    className="M_NewestExams-body-item-price-box-main-price"
                  >
                    {item.masterPrice}
                    <span>تومان</span>
                  </div>
                  <div className="M_NewestExams-body-item-price-box-discounted-price">
                    {item.price}
                    <span>تومان</span>
                  </div>
                  <div className="M_NewestExams-body-item-price-box-discount">
                    {item.badge}
                  </div>
                </div>
                <div className="M_NewestExams-body-item-info">
                  <div className="M_NewestExams-body-item-info-date">
                    <img
                      src={icon1}
                      alt="date-icon1"
                      className="M_NewestExams-body-item-info-date-icon"
                    />
                    <div className="M_NewestExams-body-item-info-date-text">
                      {moment(item.date, 'YYYY/MM/DD').format('jYYYY/jM/jD')}
                    </div>
                  </div>
                  <div className="M_NewestExams-body-item-info-level">
                    <img
                      src={icon3}
                      alt="date-icon1"
                      className="M_NewestExams-body-item-info-level-icon"
                    />
                    <div className="M_NewestExams-body-item-info-level-text">
                      {item.level}
                    </div>
                  </div>
                  <div className="M_NewestExams-body-item-info-type">
                    <img
                      src={icon2}
                      alt="date-icon1"
                      className="M_NewestExams-body-item-info-type-icon"
                    />
                    <div className="M_NewestExams-body-item-info-type-text">
                      {item.type===1 && "انفرادی"}
                      {item.type===1 && "گروهی"}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default M_NewestExams;
